
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Message from '@/components/message.vue';
import qrCode from '@/components/qrCode.vue';
import Switch from '@/components/switch.vue';
import dialog from '@/components/dialog.vue';
import uploadImg from "@/components/upload-img.vue"

import {
    activityCouponactivityCouponPageInit,
    activitycouponactivityCouponDelete,
    activitycouponactivityCouponLoseEfficacy,
    activitycouponsetIsShowForReceivePage,
    activitycouponsendMemberCouponImport,
    sendMemberCouponList,
    activitycouponCancelByMember,
    activitycouponCancelByCouponId,
    activitycouponCancelMemberCouponImport,
    cancelMemberCouponImportResultExport
} from "@/api/finance";
import {
    currentEmployeeRoleInfo
} from '@/api/order';

import axios from 'axios';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate,
        'slz-message': Message,
        'slz-switch': Switch,
        'slz-dialog': dialog,
        qrCode,
        uploadImg,
    }
})

export default class ProductList extends Vue {
    private keywords = ''
    private type = null
    private typelist = [
        { value: null, label: '全部' },
        { value: 0, label: '新人专享券' },
        { value: 1, label: '优惠券' },
    ]
    private state = null
    private statelist = [
        { value: null, label: '全部' },
        { value: 0, label: '未开始' },
        { value: 1, label: '进行中' },
        { value: 2, label: '已结束' },
    ]
    private tablelist: any = []
    private tableloading = false
    private total = 0
    private pageSize = 10
    private pageNo = 1
    private rowmsg: any = {}
    private delShow = false
    private showcode = false
    private codemsg: any = {}
    private loseShow = false
    private copyShow = false

    private tipshow = false;
    private selectData:any = {};
    private batchSeed = {
        visible: false,
        type: '1',
        fileType: '1',
        userType: '1',
        fileList: [],
        fileName: '',
        users: [{
            MemberId: '',
            MemberPhone: '',
            CouponCount: '1'
        }],
        failVisible: false,
        failReason: '',
        successVisible: false,
        uploadLoading: false
    }

    private voidCoupon: any = {
        visible: false,
        voidType: '1',
        userType: '1',
        users: [{
            MemberId: '',
            MemberPhone: '',
            CouponId: '',
        }],
        fileType: '1',
        fileList: [],
        fileName: '',
        failVisible: false,
        failReason: '',
        successVisible: false,
        uploadLoading: false,
        fileUploadSuccessTip: false,
        fileUploading: false,
        fileUploaded: false,
        failCount: 0
    }


    private activityCouponIsPartPermissions = true; //当前登录人是否部分权限


    private mounted() {
        this.gettablelist();
        this.getRole();

        setTimeout(()=>{
            // this.voidCoupon.fileUploaded = true;
        }, 1000)
    }

    /**
     * 获取权限
     */
    private async getRole(){
        let res: any = await currentEmployeeRoleInfo({})
        if (res.IsSuccess) {
            this.activityCouponIsPartPermissions = res.Result.ActivityCouponPermission;
        }
    }

    private handleCommand(e, key) {
        this.batchSeed[key] = e;
    }
    private uploadSuccess(file, name) {
        this.batchSeed.fileList = file;
        this.batchSeed.fileName = name;
    }
    private handlAddUser() {
        this.batchSeed.users.push({
            MemberId: '',
            MemberPhone: '',
            CouponCount: '1'
        })
    }
    private handleDeleteUser(index) {
        if (this.batchSeed.users.length > 1) {
            this.batchSeed.users.splice(index, 1)
        } else {
            this.$message.error('至少保留一条数据')
        }
    }
    private handleBatchExportUsers() {
        if (this.batchSeed.type == '2') {
            this.postFile();
        }else{
            this.postList();
        }
    }
    private async postFile() {
        if (!this.batchSeed.fileList) {
            this.$message.error('请上传文件')
            return
        }
        try {
            this.batchSeed.uploadLoading = true;
            let params = {
                ExcelFilePath: this.batchSeed.fileList[0],
                ExcelFileName: this.batchSeed.fileName,
                ActivityCouponId: this.selectData.Id,
                Type: this.batchSeed.fileType === '1' ? 0 : 1
            }
            // console.log(params);
            // return
            let res: any = await activitycouponsendMemberCouponImport(params)
            if (res.IsSuccess) {
                this.tipshow = true
                
            }
        } finally {
            this.batchSeed.uploadLoading = false
        }
    }
     private async postList() {
        let str = '';
        this.batchSeed.users.map(item=>{
            if (str == ''){
                if((this.batchSeed.userType == '1' && !item.MemberId) || (this.batchSeed.userType == '2' && !item.MemberPhone)){
                    str = '请输入用户信息'
                }else if (!item.CouponCount || item.CouponCount === '0'){
                    str = '请输入发放数量'
                }
            }
        })

        if (str){
            this.$message.error(str);
            return;
        }

        try {
            this.batchSeed.uploadLoading = true;
            let params = {
                Type: this.batchSeed.userType === '1' ? 0 : 1,
                SendMemberCouponListDtos: this.batchSeed.users,
                ActivityCouponId: this.selectData.Id,
                noError: true
            }
            // console.log(params);
            // return
            let res: any = await sendMemberCouponList(params)
            if (res.IsSuccess) {
                this.batchSeed.successVisible = true;
            }else{
                this.batchSeed.failVisible = true;
                this.batchSeed.failReason = res.Message;
            }
        } catch(err){
        } finally {
            this.batchSeed.uploadLoading = false
        }
    }

    private closetips() {
        this.tipshow = false;
        this.$router.push({
            path: 'coupon_grant',
            query: {
                Id: this.selectData.Id,
                Name: encodeURIComponent(this.selectData.CouponName),
            }
        })
    }

    private async showChange(val, record) {
        try {
            let res: any = await activitycouponsetIsShowForReceivePage({
                Id: record.Id,
                IsShowForReceivePage: val
            })
            if (res.IsSuccess) {
                this.$message.success('操作成功');
                this.gettablelist()
            }
        } finally {
        }
    }
    private batchgrant(row) {
        this.selectData = row;

        this.batchSeed.visible = true;

        this.batchSeed.type = '1';
        this.batchSeed.fileType = '1';
        this.batchSeed.userType = '1';
        this.batchSeed.fileList = [];
       this.batchSeed.fileName = '';
       this.batchSeed.users = [{
            MemberId: '',
            MemberPhone: '',
            CouponCount: '1'
        }];
    
    }
    
    private confirmcopy() {
        this.$router.push({
            path: 'coupon_details',
            query: {
                Id: this.rowmsg.Id,
                IsCopy: 'true'
            }
        })
    }
    private tocopy(row) {
        this.rowmsg = row
        this.copyShow = true
    }
    private tocondition(row) {
        this.$router.push({
            path: 'coupon_condition',
            query: {
                Id: row.Id,
                Name: encodeURIComponent(row.CouponName)
            }
        })
    }
    private async confirmlose() {
        try {
            this.tableloading = true
            let res: any = await activitycouponactivityCouponLoseEfficacy({
                Id: this.rowmsg.Id
            })
            if (res.IsSuccess) {
                this.$message.success('操作成功')
                this.loseShow = false
                this.gettablelist()
            }
        } finally {
            this.tableloading = false
        }
    }
    private tolose(row) {
        this.rowmsg = row
        this.loseShow = true
    }
    private previewcode(row) {
        this.rowmsg = row
        this.codemsg = {
            type: 4,
            Id: row.CouponNo,
            title: row.CouponName
        }
        this.showcode = true
    }
    private async confirmdel() {
        try {
            this.tableloading = true
            let res: any = await activitycouponactivityCouponDelete({
                Id: this.rowmsg.Id
            })
            if (res.IsSuccess) {
                this.$message.success('操作成功')
                this.delShow = false
                this.gettablelist()
            }
        } finally {
            this.tableloading = false
        }
    }
    private detele(row) {
        this.rowmsg = row
        this.delShow = true
    }
    private async gettablelist() {
        try {
            this.tableloading = true
            let res: any = await activityCouponactivityCouponPageInit({
                Keywords: this.keywords,
                ActivityCouponType: this.type,
                ActivityCouponState: this.state,
                Skip: (this.pageNo - 1) * this.pageSize,
                Take: this.pageSize
            })
            if (res.IsSuccess) {
                this.tablelist = res.Result.Results
                this.total = res.Result.Total
            }
        } finally {
            this.tableloading = false
        }
    }
    private doSearch() {
        this.pageNo = 1
        this.gettablelist()
    }
    private clearSearch() {
        this.keywords = ''
        this.type = null
        this.state = null
        this.doSearch()
    }
    private changePage(e) {
        this.pageNo = e
        this.gettablelist()
    }
    private todetails(row) {
        this.$router.push({
            path: 'coupon_details',
            query: {
                Id: row.Id,
            }
        })
    }


    private batchVoidCoupon(record){
        this.selectData = record;
        this.voidCoupon.visible = true;
        this.voidCoupon.voidType =  '1';
        this.voidCoupon. userType =  '1';
        this.voidCoupon.users =  [{
            MemberId: '',
            MemberPhone: '',
            CouponId: '',
        }];
        this.voidCoupon. fileType =  '1';
        this.voidCoupon.fileList =  [];
        this.voidCoupon.fileName = '';
        this.voidCoupon.failReason =  '';
    }
    private handleVoidCommand(e, key) {
        this.voidCoupon[key] = e;
    }
    private handleDeleteVoidUser(index){
        this.voidCoupon.users.splice(index, 1)
    }
    private handlAddVoidUser(){
        this.voidCoupon.users.push({
            MemberId: '',
            MemberPhone: '',
            CouponId: '',
        })
    }
     private voidUploadSuccess(file, name) {
        this.voidCoupon.fileList = file;
        this.voidCoupon.fileName = name;
    }

    private handleBatchVoidCoupon() {
        if (this.voidCoupon.voidType !== '3') {
            this.postVoiUsers();
        }else{
            this.postVoidFiles();
        }
    }
    private async postVoiUsers(){
        let str = '';
        this.voidCoupon.users.map(item=>{
            if (str == ''){
                if (this.voidCoupon.voidType === '1'){
                    if((this.voidCoupon.userType == '1' && !item.MemberId) || (this.voidCoupon.userType == '2' && !item.MemberPhone)){
                        str = '请输入用户信息'
                    }
                }
                console.log(item.CouponId)
                if (this.voidCoupon.voidType === '2' && !item.CouponId){
                    str = '请输入优惠券ID';
                }
            }
        })

        if (str){
            this.$message.error(str);
            return;
        }

        try {
            this.voidCoupon.uploadLoading = true;
            let params = {};

            if (this.voidCoupon.voidType === '1' && this.voidCoupon.userType === '1'){
                params = {
                    Type: 0,
                    ActivityCouponId: this.selectData.Id,
                    MemberIdList: this.voidCoupon.users.map(item=>{
                        return item.MemberId
                    }),
                    noError: true
                }
            }
            if (this.voidCoupon.voidType === '1' && this.voidCoupon.userType === '2'){
                params = {
                    Type: 1,
                    ActivityCouponId: this.selectData.Id,
                    MemberPhoneList: this.voidCoupon.users.map(item=>{
                        return item.MemberPhone
                    }),
                    noError: true
                }
            }
            if (this.voidCoupon.voidType === '2'){
                params = {
                    ActivityCouponId: this.selectData.Id,
                    CouponIdList: this.voidCoupon.users.map(item=>{
                        return item.CouponId
                    }),
                    noError: true
                }
            }
            // console.log(params);
            // return

            let res: any = {};
            if (this.voidCoupon.voidType === '1'){
                res = await activitycouponCancelByMember(params)
            }
            if (this.voidCoupon.voidType === '2'){
                res = await activitycouponCancelByCouponId(params)
            }
            if (res.IsSuccess) {
                this.voidCoupon.successVisible = true;
            }else{
                this.voidCoupon.failVisible = true;
                this.voidCoupon.failReason = res.Message;
            }
        } catch(err){
        } finally {
            this.voidCoupon.uploadLoading = false
        }
    }
    private async postVoidFiles(){
         if (!this.voidCoupon.fileList) {
            this.$message.error('请上传文件')
            return
        }
        try {
            this.voidCoupon.uploadLoading = true;
            let params = {
                ExcelFilePath: this.voidCoupon.fileList[0],
                ExcelFileName: this.voidCoupon.fileName,
                Type: this.voidCoupon.fileType-1,
                ActivityCouponId: this.selectData.Id
            }
            // console.log(params);
            // return
            let res: any = await activitycouponCancelMemberCouponImport(params)
            if (res.IsSuccess) {
                this.voidCoupon.fileUploading = true;
                this.voidCoupon.visible = false;
                this.checkIsSuccess(res.Result.RecordId);
            }
        } finally {
            this.voidCoupon.uploadLoading = false
        }
    }
    private async checkIsSuccess(recordId){
        
        try {

            const res: any = await axios.get(`/pc/activitycoupon/cancelMemberCouponImportResultExport?RecordId=${recordId}&IsExport=false`)

            const dt = res.data.Result;
            
            if (dt.IsDealFinish){
                this.voidCoupon.fileUploading = false;
                this.voidCoupon.fileUploaded = true;
                this.voidCoupon.failCount = dt.FailCount;
                this.voidCoupon.recordId = recordId;
            }else{
                setTimeout(()=>{
                    this.checkIsSuccess(recordId);
                }, 1000)
            }
            
        } finally {
        }
    }
    private handleDownloadFailResult(){
        const url = `${location.origin}/pc/activitycoupon/cancelMemberCouponImportResultExport?RecordId=${this.voidCoupon.recordId}&IsExport=true`;
        window.open(url)
    }
}
